import React,{useId,useLayoutEffect,useRef} from 'react';
import {createPortal} from 'react-dom';
import {X} from 'lucide-react';
import {useLang} from './i18n';
import './admin-dialog.css';

let openDialogs=0,previousOverflow='';

// Native modal dialogs stay above the workspace and keep keyboard focus inside,
// including when a second action opens from an account's detail dialog.
export function AdminDialog({title,children,onClose,busy=false,wide=false}:{title:React.ReactNode;children:React.ReactNode;onClose:()=>void;busy?:boolean;wide?:boolean}){
 const ref=useRef<HTMLDialogElement>(null),headingId=useId(),[,,tr]=useLang();
 useLayoutEffect(()=>{
  const dialog=ref.current!,opener=document.activeElement as HTMLElement|null;
  if(openDialogs++===0){previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden'}
  dialog.showModal();
  const measure=()=>{
   const scale=dialog.getBoundingClientRect().width/(dialog.offsetWidth||1)||1;
   dialog.style.setProperty('--admin-visible-width',(window.visualViewport?.width||innerWidth)/scale+'px');
   dialog.style.setProperty('--admin-visible-height',(window.visualViewport?.height||innerHeight)/scale+'px');
  };
  measure();
  const appearance=new MutationObserver(measure);appearance.observe(document.documentElement,{attributes:true,attributeFilter:['style','class']});appearance.observe(document.body,{attributes:true,attributeFilter:['style','class']});
  window.addEventListener('resize',measure);window.visualViewport?.addEventListener('resize',measure);
  (dialog.querySelector<HTMLElement>('[autofocus],input:not([disabled]),select:not([disabled]),textarea:not([disabled])')||dialog).focus();
  return()=>{appearance.disconnect();window.removeEventListener('resize',measure);window.visualViewport?.removeEventListener('resize',measure);dialog.close();if(--openDialogs===0)document.body.style.overflow=previousOverflow;if(opener?.isConnected)opener.focus({preventScroll:true})};
 },[]);
 return createPortal(<dialog ref={ref} data-native-select tabIndex={-1} className={'admin-workspace-dialog'+(wide?' is-wide':'')} aria-labelledby={headingId} onCancel={e=>{if(e.target!==e.currentTarget)return;e.preventDefault();e.stopPropagation();if(!busy)onClose()}} onKeyDown={e=>{
  if(!(e.target instanceof Node)||!e.currentTarget.contains(e.target))return;
  e.stopPropagation();
  if(e.key!=='Tab')return;
  const items=Array.from(e.currentTarget.querySelectorAll<HTMLElement>('button:not(:disabled),input:not(:disabled),select:not(:disabled),textarea:not(:disabled),a[href],[tabindex="0"]')).filter(el=>el.getClientRects().length&&!el.closest('[inert]'));
  const first=items[0],last=items.at(-1);
  if(!first){e.preventDefault();e.currentTarget.focus()}
  else if(e.shiftKey&&(document.activeElement===first||document.activeElement===e.currentTarget)){e.preventDefault();last?.focus()}
  else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
 }}>
  <header className="admin-dialog-heading"><h2 id={headingId}>{title}</h2><button type="button" disabled={busy} onClick={onClose} aria-label={tr('Close','Schließen')}><X size={20}/></button></header>
  <div className="admin-dialog-body">{children}</div>
 </dialog>,document.body);
}
